// extracted by mini-css-extract-plugin
module.exports = {"container":"_961f784","valueRed":"_906451c"};